/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2019, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function() {

	class ContentActionUtil {
		static getNodes(controller, idList) {
			const nodes = [];
			idList.forEach(id => {
				const layoutView = controller.layoutController.getLayoutView(id);
				if (layoutView && layoutView.domNode) {
					nodes.push(layoutView.domNode);
				}
			});
			return nodes;
		}

		/**
		 * Retrieve and return an array of content actions base on the specified content ids
		 *
		 * @param {DashboardAPI} dashboard
		 * @param {ContentActionsAPI} contentActions
		 * @param {string[]} selectedIds - array of selection content ids on the canvas
		 *
		 * @return {actions[]} actions - array of content actions
		 */
		static getContentActionList (dashboard, contentActions, selectedIds = []) {
			const canvas = dashboard.getCanvas();
			const actions = contentActions.getContentActionList(selectedIds);
			// In 11.2.2 only one widget is allow to enter text editing at any given time
			// so exit search once found a content that has text editing
			selectedIds.some(id => {
				const layoutApi = canvas.getLayout(id);
				const editingActions = layoutApi && layoutApi.getEditingActionList();
				const hasActions = editingActions && editingActions.length;
				if (hasActions) {
					actions.push(...editingActions);
				}
				return hasActions;
			});
			return actions;
		}
	}

	return ContentActionUtil;
});
